/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
import { useState } from "react";
import AppBanners from "./AppBanners";
import BackendBanners from "./BackendBanners";
import Banners from "./Banners";
const Banner = () => {
  const tab = localStorage.getItem("activeTabForBanner");
  const [activeTab, setActiveTab] = useState(tab ? tab : "backend-banners");

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    localStorage.setItem("activeTabForBanner", tabName);
  };
  return (
    <>
      <div className="row ">
        <div className="new_wrapper_of_header">
          <p className="header-text mb-1 mt-2">Banner</p>
        </div>
        <div className="col-12 white-box mt-4">
          <div className="row p-1 Tab mt-2 ">
            <div className="col-2">
              <span
                style={{ cursor: "pointer" }}
                onClick={() => handleTabClick("backend-banners")}
                className={
                  activeTab === "backend-banners"
                    ? "active mb-3 pb-3"
                    : " mb-3 pb-2"
                }
              >
                Backend Banners
              </span>
            </div>
            <div className="col-2">
              <span
                style={{ cursor: "pointer" }}
                onClick={() => handleTabClick("app-banners")}
                className={
                  activeTab === "app-banners"
                    ? "active  mb-3 pb-3"
                    : " mb-3 pb-2"
                }
              >
                Flash Screen Banners
              </span>
            </div>
            <div className="col-2">
              <span
                style={{ cursor: "pointer" }}
                onClick={() => handleTabClick("banners")}
                className={
                  activeTab === "banners"
                    ? "active  mb-3 pb-3"
                    : " mb-3 pb-2"
                }
              >
                Banners
              </span>
            </div>

            <span
              className="col-12 border-bottom banner_bottom_line"
            ></span>
          </div>

          {activeTab === "backend-banners" && <BackendBanners />}
          {activeTab === "app-banners" && <AppBanners />}
          {activeTab === "banners" && <Banners />}
        </div>
      </div>
    </>
  );
};

export default Banner;
